import alert from '../../templates/_helpers/alert.hbs';

export default function Alert(type = 'danger', text = '', title = null, dismissable = true) {
    return $(alert({
        type:type,
        text:text,
        title:title,
        dismissable:dismissable
    }));
}